module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"manager_review_desc":"このレビューは%{brandName}管理者が登録したレビューです。"}}')
  delete Component.options._Ctor
}
